import { InitMyOrganizationInfo, MyOrganizationInfo } from "@models/organization.model";
import { LandingPageProjectInfo } from "@models/projects.model";
import { UserInfo, InitUserInfo } from "@models/user.model";
import { AuthProps } from "./provider";

export type ActionType = 
    | {
        type: 'login' | 'refreshLogin' 
        userInfo: UserInfo
        organizationInfo: MyOrganizationInfo
        landingPageProjects: LandingPageProjectInfo[]
        completedInitiated: boolean
      }
    | {
        type: 'updateProfile'
        userInfo: UserInfo
      }
    | {
        type: 'logout' | 'changePassword'
      }
      
export default function AuthReducer(state: AuthProps, action: ActionType): AuthProps {
    console.log(action)
    switch (action.type) {
        case 'login':
        case 'refreshLogin':
            return {
                ...state,
                userInfo: action.userInfo,
                organizationInfo: action.organizationInfo,
                landingPageProjects: action.landingPageProjects,
                completedInitiated: action.completedInitiated
            }
        
        case 'logout':
        case 'changePassword':
            return {
                ...state,
                userInfo: InitUserInfo,
                organizationInfo: InitMyOrganizationInfo,
                landingPageProjects: []
            }
        case 'updateProfile': 
            return {
                ...state,
                userInfo: action.userInfo
            } 
        default: 
            throw new Error();
    }
}